import berelPhoto from "../../../assets/images/landing/team/berel-levertov.jpg";
import danielPhoto from "../../../assets/images/landing/team/daniel-cotlar.png";
import kushiPhoto from "../../../assets/images/landing/team/kushi-shusterman.jpg";
import yisroelPhoto from "../../../assets/images/landing/team/yisroel-dolnikov.jpg";
import eliPhoto from "../../../assets/images/landing/team/eli-kaminetzky.jpg";

// Ordered list of team member ids + photos. The translatable name/role/bio
// for each id lives under the `landing_team.members.<id>` i18n key (see
// public/locales/*/translation.json) and is merged in at render time by
// TeamPage, so this file only owns the (non-translatable) image assets and
// display order.
export interface TeamMemberConfig {
  id: string;
  photo: string;
}

export const TEAM_MEMBERS: TeamMemberConfig[] = [
  { id: "berel_levertov", photo: berelPhoto },
  { id: "daniel_cotlar", photo: danielPhoto },
  { id: "kushi_shusterman", photo: kushiPhoto },
  { id: "yisroel_dolnikov", photo: yisroelPhoto },
  { id: "eli_kaminetzky", photo: eliPhoto },
];
